'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function AppIconNaverOff(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_AppIconNaverOff');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.39062C0 2.41347 2.41347 0 5.39062 0H18.6094C21.5865 0 24 2.41347 24 5.39062V18.6094C24 21.5865 21.5865 24 18.6094 24H5.39062C2.41347 24 0 21.5865 0 18.6094V5.39062Z",
    fill: "url(#paint0_linear_12532_19553)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7331 6.54541V12.0483L10.2814 6.54541H6.54541V17.4545H10.269V11.9497L13.7221 17.4545H17.4545V6.54541H13.7331Z",
    fill: fill || 'white'
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12532_19553",
    x1: 12,
    y1: 3.57628e-7,
    x2: 12,
    y2: 22.9091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508972,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A2A2"
  }))));
}
var AppIconNaverOff$1 = /*#__PURE__*/memo(AppIconNaverOff);

export { AppIconNaverOff$1 as default };
